import api from './api';

export interface SearchResult {
    type: 'inspection' | 'vehicle';
    id: number;
    title: string;
    subtitle: string;
    metadata?: {
        status?: string;
        created_at?: string;
        vehicle_number?: string;
        progress?: number;
    };
}

export interface SearchResponse {
    results: SearchResult[];
    total: number;
}

/**
 * Search inspections and vehicles
 */
export const search = async (query: string, workshopId?: number): Promise<SearchResponse> => {
    if (!query.trim()) {
        return { results: [], total: 0 };
    }

    // Build URL with query parameter manually to avoid nesting
    const encodedQuery = encodeURIComponent(query);
    let url = `/search?q=${encodedQuery}`;

    // Add workshop filter if provided
    if (workshopId) {
        url += `&workshop_id=${workshopId}`;
    }

    const response = await api.get<SearchResponse>(url);

    return response;
};

/**
 * Local search history management
 */
const SEARCH_HISTORY_KEY = 'inspection_search_history';
const MAX_HISTORY_ITEMS = 10;

export const getSearchHistory = (): string[] => {
    try {
        const history = localStorage.getItem(SEARCH_HISTORY_KEY);
        return history ? JSON.parse(history) : [];
    } catch {
        return [];
    }
};

export const addToSearchHistory = (query: string): void => {
    if (!query.trim()) return;

    const history = getSearchHistory();

    // Remove if already exists
    const filtered = history.filter(item => item !== query);

    // Add to beginning
    filtered.unshift(query);

    // Keep only MAX_HISTORY_ITEMS
    const limited = filtered.slice(0, MAX_HISTORY_ITEMS);

    localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(limited));
};

export const removeFromSearchHistory = (query: string): void => {
    const history = getSearchHistory();
    const filtered = history.filter(item => item !== query);
    localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(filtered));
};

export const clearSearchHistory = (): void => {
    localStorage.removeItem(SEARCH_HISTORY_KEY);
};
